import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import JobCard from "@/components/JobCard";
import { Link } from "react-router-dom";

export default function SavedJobsPage() {
  const [items, setItems] = useState([]);
  const [savedSet, setSavedSet] = useState(new Set());

  const load = async () => {
    const r = await api.get("/saved-jobs/me");
    const ids = (r.data.items || []).map((i) => i.job_id);
    setSavedSet(new Set(ids));
    if (ids.length) {
      const detailed = await Promise.all(ids.map((id) => api.get(`/jobs/${id}`).then((x) => x.data).catch(() => null)));
      setItems(detailed.filter(Boolean));
    } else {
      setItems([]);
    }
  };
  useEffect(() => { load(); }, []);

  const onSave = async (jobId, willSave) => {
    if (willSave) await api.post(`/saved-jobs/${jobId}`);
    else await api.delete(`/saved-jobs/${jobId}`);
    load();
  };

  return (
    <div className="container py-10">
      <p className="eyebrow mb-1">Saved roles</p>
      <h1 className="display-2 mb-8">{items.length} bookmarked</h1>
      {items.length === 0 ? (
        <div className="vital-card-static p-10 text-center text-muted-foreground" data-testid="saved-empty">
          Nothing saved yet. <Link to="/jobs" className="text-primary underline">Discover roles →</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((j) => <JobCard key={j.job_id} job={j} onSave={onSave} saved={savedSet.has(j.job_id)} />)}
        </div>
      )}
    </div>
  );
}
